import React, {useState} from 'react';
import {Flex, Form, Input, message} from "antd";
import classes from './cert.module.css';
import FormItem from "antd/es/form/FormItem";
import {clrs} from "../../constants/colors";
import CertificateService from "../../services/CertificateService";
import IntlMessage, {IntlMessageText} from "../../components/IntlMessage/IntlMessage";
import Header from "../components/Header/Header";
import MyText from "../../components/UI/Text/MyText";
import Footer from "../components/Footer/Footer";
import GreyButton from "../../components/UI/Buttons/GreyButton";
import {Document, Page} from "react-pdf";
import {API_BASE_URL} from "../../constants/api";

const CertificatesPage = () => {

    const [form] = Form.useForm();
    const certCode = Form.useWatch('certCode', form);

    const [isLoading, setIsLoading] = useState(false);

    const [certificate, setCertificate] = useState(null);

    function handleCheck() {
        setCertificate(null)
        form.validateFields()
            .then(async () => {
                setIsLoading(true);
                message.loading(<IntlMessage id={'searching'}/>, 0);
                await CertificateService.getCertificateByCode(certCode)
                    .then((r) => {
                        message.destroy();
                        message.success(<IntlMessage id={'success'}/>, 5);
                        setCertificate(r.data);
                    })
                    .catch(() => {
                        message.destroy();
                        message.error(<IntlMessage id={'error'}/>, 5);
                    })
                    .finally(() => {
                        setIsLoading(false);
                    })
            })
            .catch(() => {
                console.log("Validation error!")
            })
    }

    function triggerDownload(blob, filename) {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); // Set the download attribute with a filename
        document.body.appendChild(link);
        link.click();

        // Clean up and revoke the URL after download
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    async function downloadDocument(certificateId) {
        message.loading(<IntlMessage id={'loading'}/>, 0);
        await CertificateService.getResourceById(certificateId)
            .then((r) => {
                message.destroy();
                message.success(<IntlMessage id={'success'}/>, 5);
                if (certificate?.form) {
                    triggerDownload(r.data, certificate?.form?.docDetails !== null ? (certificate?.form?.docDetails + ".pdf") : "certificate.pdf")
                } else {
                    triggerDownload(r.data, "certificate.pdf")
                }

            })
            .catch(() => {
                message.destroy();
                message.error(<IntlMessage id={'error'}/>, 5);
            })
    }

    return (
        <div>
            <Header/>
            <Flex style={{width: "100%", position: "relative", padding: "120px 20px 20px 20px"}} align={"center"}
                  justify={"center"}>
                <Flex gap={50}
                      style={{width: "100%", maxWidth: 1440, position: "relative", minHeight: "calc(100vh - 300px)"}}
                      vertical align={"center"} justify={"center"}>
                    <MyText uppercase strong size={"large"}><IntlMessage id={'verificationCertificates'}/></MyText>
                    <Form form={form} className={classes.formBlock}>
                        <FormItem rules={[{
                            required: true,
                            message: <IntlMessage id={'requiredField'}/>,
                        },
                        ]} label={<IntlMessage id={'certCode'}/>} labelCol={{span: 24}}
                                  className={classes.formInputBlock} name="certCode">
                            <Input rootClassName={classes.formInput}
                                   placeholder={IntlMessageText.getText({id: 'certCode'})}/>
                        </FormItem>
                        <FormItem className={classes.formInputBlock}>
                            <Flex align={"center"} justify={"center"} style={{width: "100%"}} gap={20}>
                                <GreyButton onClick={handleCheck} backgroundColor={clrs.blackerBlue}
                                            fontColor={clrs.white}><IntlMessage id={'check'}/></GreyButton>
                            </Flex>
                        </FormItem>
                    </Form>
                    {certificate &&
                        <Flex gap={50}
                              style={{
                                  width: "100%",
                                  position: "relative",
                              }}
                              vertical
                              align={"flex-start"}
                              justify={"flex-start"}>
                            <Flex align={"center"} justify={"center"} vertical
                                  style={{overflowX: "auto", overflowY: "hidden", width: "100%"}} gap={20}>
                                {/*<Flex style={{*/}
                                {/*    zIndex: 1,*/}
                                {/*    padding: "10px 20px",*/}
                                {/*    backgroundColor: "white",*/}
                                {/*    borderRadius: 10,*/}
                                {/*    boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.1)",*/}
                                {/*}} gap={15} justify={"space-between"} align={"center"}>*/}
                                {/*    <Button disabled={pageNumber === 1} onClick={() => {*/}
                                {/*        setPageNumber(pageNumber - 1)*/}
                                {/*    }}>*/}
                                {/*        {'<'}*/}
                                {/*    </Button>*/}
                                {/*    <MyText size={"small"}>*/}
                                {/*        {pageNumber} / {numPages}*/}
                                {/*    </MyText>*/}
                                {/*    <Button disabled={pageNumber === numPages} onClick={() => {*/}
                                {/*        setPageNumber(pageNumber + 1)*/}
                                {/*    }}>*/}
                                {/*        {'>'}*/}
                                {/*    </Button>*/}
                                {/*</Flex>*/}
                                <Document file={API_BASE_URL + "/api/certificate/resource/code/" + certificate.code}
                                    // onLoadSuccess={onDocumentLoadSuccess}
                                          loading={<IntlMessage id={'documentIsLoading'}/>}
                                >
                                    <Page pageNumber={1} width={700}/>
                                </Document>
                            </Flex>
                            <Flex align={"flex-start"} justify={"center"} gap={20} style={{width: "100%"}}>
                                <GreyButton onClick={() => downloadDocument(certificate.code)}>
                                    <IntlMessage id={'downloadCertificate'}/>
                                </GreyButton>
                            </Flex>
                        </Flex>
                    }
                </Flex>
            </Flex>
            <Footer/>
        </div>
    );
};

export default CertificatesPage;